(function ($, drupalSettings) {
    'use strict';

    if (!drupalSettings) {
        drupalSettings = {};
    }

    console.log(drupalSettings.heroslider);

    const PAUSE_LABEL = drupalSettings.heroslider.heroslider_pause_label || 'Pause Slideshow';
    const PLAY_LABEL = drupalSettings.heroslider.heroslider_play_label || 'Resume Slideshow';
    const AUTOPLAY = true;                  //automatically loop through slides
    const STOP_AFTER_FIRST_LOOP = true;     //only iterate through slides once, then stop on the first slide

    $('.paragraph--type--hero-slider:not(.initialized)').each(function() {
        var $slider = $(this).addClass('initialized autoplay'),
            $playpause = $('<button class="playpause" type="button">Play/Pause</button>').attr('title', PAUSE_LABEL),
            uninterrupted = true;

        $slider
        .slick({
            dots: true,
            autoplay: AUTOPLAY,
            autoplaySpeed: drupalSettings.heroslider.heroslider_speed || 3000,
        });

        if (AUTOPLAY) {
            $slider
            .append($playpause)
            .on('pause', function() {
                $slider.removeClass('autoplay').slick('slickPause');
                $playpause.attr('title', PLAY_LABEL);
                uninterrupted = false;
            })
            .on('play', function() {
                $slider.addClass('autoplay').slick('slickPlay');
                $playpause.attr('title', PAUSE_LABEL);
                uninterrupted = false;
            })
            .on('click', '.playpause', function() {
                if ($slider.is('.autoplay')) {
                    $slider.trigger('pause');
                } else {
                    $slider.trigger('play');
                }
            });
        }

        if (AUTOPLAY && STOP_AFTER_FIRST_LOOP) {
            $slider
            .on('afterChange', function(event, slick, currentSlide) {
                //when first returning to first slide, stop autoplay (except when autoplay had been paused/resumed before)
                if (currentSlide == 0 && uninterrupted) {
                    $slider.trigger('pause');
                }
            });
        }
    });

}(jQuery, drupalSettings));
